import { Pagination as BasePagination } from "antd";
import styled, { css } from "styled-components";

import handleSpaces, { spacingProps } from "../utils/handleSpaces";
import color from "../_style/color";

const type = {
  basic: css`
    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
      color: ${color.highempahis};
      :hover {
        color: ${color.primary};
      }
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      border: 1px solid ${color.gainsboro};
      a {
        padding: 0 10px;
      }
    }

    .ant-pagination-prev,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      margin-right: 0;
      border: 1px solid ${color.gainsboro};
    }

    .ant-pagination-item {
      margin-right: 0;
      border-radius: 0;
      border-color: ${color.gainsboro};

      a {
        color: ${color.highempahis};
        :hover {
          color: ${color.primary};
        }
      }
    }

    .ant-pagination-item-active {
      a {
        color: ${color.highempahis};
        font-weight: 600;
      }
      background: ${color.gainsboro};
    }

    .ant-pagination-prev:focus .ant-pagination-item-link,
    .ant-pagination-next:focus .ant-pagination-item-link,
    .ant-pagination-prev:hover .ant-pagination-item-link,
    .ant-pagination-next:hover .ant-pagination-item-link {
      border: 1px solid ${color.gainsboro};
      color: ${color.highempahis};
      border-color: ${color.gainsboro};
    }
  `,
};

const Pagination = styled(BasePagination).attrs((props) => ({
  type: props.type || "basic",
  ...spacingProps(props),
}))`
  ${(props) => type[props.type]};
  ${(props) =>
    css`
      ${handleSpaces(props)}
    `}
`;

export default Pagination;
